import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { NAV_LINKS } from "@/lib/data";

export const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => setOpen(false), [location.pathname]);

    return (
        <header
            data-testid="site-navbar"
            className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
                scrolled || open ? "bg-sf-black/90 backdrop-blur-xl border-b border-white/10" : "bg-transparent border-b border-transparent"
            }`}
        >
            <div className="sf-container flex items-center justify-between h-20">
                <Link to="/" data-testid="nav-logo-link" className="flex items-center gap-3 shrink-0">
                    <img src="/logo.jpg" alt="Super Finishers" className="h-11 w-11 object-cover" />
                    <span className="hidden sm:block">
                        <span className="block font-display font-extrabold tracking-wide text-white text-sm leading-none">SUPER FINISHERS</span>
                        <span className="block font-mono text-[9px] tracking-[0.3em] text-sf-green mt-1">SUCCESS THROUGH QUALITY</span>
                    </span>
                </Link>

                <nav className="hidden xl:flex items-center gap-7" data-testid="nav-desktop-menu">
                    {NAV_LINKS.slice(1, 7).map((link) => (
                        <NavLink
                            key={link.path}
                            to={link.path}
                            data-testid={`nav-link-${link.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                            className={({ isActive }) =>
                                `sf-nav-link font-mono text-[11px] tracking-[0.2em] uppercase transition-colors duration-300 ${
                                    isActive ? "text-sf-green is-active" : "text-white/60 hover:text-white"
                                }`
                            }
                        >
                            {link.label}
                        </NavLink>
                    ))}
                    <Link
                        to="/contact"
                        data-testid="nav-contact-cta"
                        className="inline-flex items-center gap-2 bg-sf-green text-sf-black font-display font-bold text-xs tracking-wider uppercase px-5 py-2.5 transition-colors duration-300 hover:bg-white"
                    >
                        Enquire <ArrowUpRight size={14} />
                    </Link>
                </nav>

                <button
                    data-testid="nav-mobile-toggle"
                    className="xl:hidden text-white p-2"
                    onClick={() => setOpen(!open)}
                    aria-label="Toggle menu"
                >
                    {open ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            {open && (
                <nav className="xl:hidden border-t border-white/10 bg-sf-black" data-testid="nav-mobile-menu">
                    {NAV_LINKS.map((link) => (
                        <NavLink
                            key={link.path}
                            to={link.path}
                            data-testid={`nav-mobile-link-${link.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                            className={({ isActive }) =>
                                `block px-6 py-4 font-mono text-xs tracking-[0.25em] uppercase border-b border-white/5 transition-colors duration-300 ${
                                    isActive ? "text-sf-green" : "text-white/70"
                                }`
                            }
                        >
                            {link.label}
                        </NavLink>
                    ))}
                </nav>
            )}
        </header>
    );
};
